export default __webpack_public_path__ + "static/media/ne.66cb0cd9.svg";